import type { WavesChart } from '../wavesChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_FOREST } from '../builtinPulseMaps/palettes.js';
import { assembleWavesChartFromCircles } from './wavesFromCircles.js';
import audioOnsets from '../circlesBuiltinMaps/audio/adventure.onsets.json' with { type: 'json' };
import normalImported from '../circlesBuiltinMaps/imported/adventure-normal.circles.json' with { type: 'json' };
import hardImported from '../circlesBuiltinMaps/imported/adventure-hard.circles.json' with { type: 'json' };
import extremeImported from '../circlesBuiltinMaps/imported/adventure-extreme.circles.json' with { type: 'json' };

export const ADVENTURE_WAVES_VARIANTS: Record<Variant, WavesChart> = assembleWavesChartFromCircles({
  baseSlug: 'adventure',
  baseTitle: "Adventure",
  description: "JJD's melodic glitch hop. Soft mid-tier wave run with a strong melodic hook.",
  difficulty: 2,
  palette: PALETTE_FOREST,
  audioSrc: '/audio/waves/adventure.mp3',
  attribution: "\"Adventure\" by JJD [NCS Release] - https://ncs.io/Adventure",
  mapper: "GGPLAYS_YT",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 110, offsetMs: 14052.6, totalBeats: 87 },
    hard: { bpm: 101, offsetMs: 0, totalBeats: 104 },
    extreme: { bpm: 160, offsetMs: 0, totalBeats: 163 },
  },
});
